// src/utils/provenance.tsx
import React from 'react';
import { Info } from 'lucide-react';

interface ProvenanceProps {
  source: string;
  updatedAt?: string | null;
  className?: string;
}

export function Provenance({ source, updatedAt, className = '' }: ProvenanceProps) {
  if (!source) return null;
  
  // Format the updated date if provided
  const formattedDate = updatedAt 
    ? new Date(updatedAt).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    : null;
  
  const tooltipText = `${source}${formattedDate ? ` • ${formattedDate}` : ''}`;
  
  return (
    <span 
      className={`inline-flex items-center text-xs text-gray-400 cursor-help ml-1 hover:text-gray-600 transition-colors ${className}`}
      title={tooltipText}
      aria-label="Data provenance information"
    >
      <Info className="w-3 h-3" />
    </span>
  );
}

// Optional: Export a component for inline provenance display
export function InlineProvenance({ source, updatedAt }: ProvenanceProps) {
  if (!source) return null;
  
  const formattedDate = updatedAt 
    ? new Date(updatedAt).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      })
    : null;
  
  return (
    <span className="text-xs text-gray-500 italic ml-2">
      ({source}{formattedDate ? ` • ${formattedDate}` : ''})
    </span>
  );
}